import React, { useEffect, useState, useRef, useMemo } from "react";
import { setCurrentPageTitle } from '../../store/slices/pageSlice';
import { useDispatch, useSelector } from "react-redux";
import ConfirmationModal from "../../components/common/confirm/ConfirmationModal";
import AdminLoader from "../../components/common/loader/AdminLoader";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from '@mui/icons-material/Add';
import { fetchGroups } from "../../store/slices/groupSlice";
import { fetchEmployees } from "../../store/slices/employeeSlice";
import { useSnackbar } from "notistack";
import { createEmployeeGroups, deleteEmployeeGroup, fetchEmployeeGroups, updateEmployeeGroup } from "../../store/slices/employeeGroup";
import DeleteIcon from '@mui/icons-material/Delete';
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { MdSearch } from "react-icons/md";
import { hasFeatureAccess } from "../../utils/featureAccessUtils";

const MyMember = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, SetisLoading] = useState(false);
  const [hoveredRowId, setHoveredRowId] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending'
  });
  const [openDropdowns, setOpenDropdowns] = useState({
    group: {},
    manager: {}
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const dropdownRefs = useRef({});
  const { group } = useSelector((state) => state.group);
  const { employees } = useSelector((state) => state.employees);
  const { groups: employeeGroups } = useSelector((state) => state.employeeGroup);
  const [groupRows, setGroupRows] = useState([]);
  const [initialGroupRows, setInitialGroupRows] = useState([]);
  const [_id, setRowToDelete] = useState(null);
  const [GroupNames, setGroupNames] = useState([]);
  const [Employees, setEmployees] = useState([]);
  const [Group, setGroup] = useState([]);
  const [isGroupOpen, setIsGroupOpen] = useState(false);
  const [AssignedGroup, setAssignedGroup] = useState("");
  const hasUserSelectedGroup = useRef(false);
  console.log("mymember Employees", Employees)
  const [rowKeyToDelete, setRowKeyToDelete] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const userEmail = localStorage.getItem("email") || "";
  const currentEmployee = useMemo(
    () => employees.find((emp) => emp.EmpEmail === userEmail),
    [employees, userEmail]
  );

  const hasConfiguredFeatureAccess = useMemo(
    () =>
      Array.isArray(currentEmployee?.featureAccess) &&
      currentEmployee.featureAccess.length > 0,
    [currentEmployee]
  );

  // Permissions for Add Member actions (Sales person L3 – ERP)
  const canAddMember = useMemo(() => {
    if (!hasConfiguredFeatureAccess) return true;
    // Admin / Director should always retain full control
    if (["L0", "L1"].includes(currentEmployee?.EmpAuthLevel)) return true;
    return hasFeatureAccess(currentEmployee, "ADD MEMBER ADD MEMBER");
  }, [hasConfiguredFeatureAccess, currentEmployee]);

  const canEditMember = useMemo(() => {
    if (!hasConfiguredFeatureAccess) return true;
    if (["L0", "L1"].includes(currentEmployee?.EmpAuthLevel)) return true;
    return hasFeatureAccess(currentEmployee, "ADD MEMBER EDIT MEMBER");
  }, [hasConfiguredFeatureAccess, currentEmployee]);

  const canDeleteMember = useMemo(() => {
    if (!hasConfiguredFeatureAccess) return true;
    if (["L0", "L1"].includes(currentEmployee?.EmpAuthLevel)) return true;
    return hasFeatureAccess(currentEmployee, "ADD MEMBER DELETE MEMBER");
  }, [hasConfiguredFeatureAccess, currentEmployee]);


  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    let baseFilteredRows = groupRows;
    if (AssignedGroup !== "All" && AssignedGroup) {
      baseFilteredRows = groupRows.filter(row =>
        row.selectedGroup?.newGroupName === AssignedGroup
      );
    }

    if (!query.trim()) {
      setFilteredRows(baseFilteredRows);
      return;
    }

    const filtered = baseFilteredRows.filter(row => {
      // Search in group name
      const groupNameMatch = row.selectedGroup?.newGroupName?.toLowerCase().includes(query.toLowerCase());

      // Search in manager name
      const managerFirstNameMatch = row.selectedManager?.EmpFirstName?.toLowerCase().includes(query.toLowerCase());
      const managerLastNameMatch = row.selectedManager?.EmpLastName?.toLowerCase().includes(query.toLowerCase());
      const managerFullName = `${row.selectedManager?.EmpFirstName || ''} ${row.selectedManager?.EmpLastName || ''}`.toLowerCase();
      const managerFullNameMatch = managerFullName.includes(query.toLowerCase());

      // Search in service type
      const serviceTypeMatch = row.selectedManager?.servicetype?.toLowerCase().includes(query.toLowerCase());

      // Search in custom roles
      const customRolesMatch = row.selectedManager?.customRoles?.some(role =>
        role.toLowerCase().includes(query.toLowerCase())
      );

      return groupNameMatch || managerFirstNameMatch || managerLastNameMatch ||
        managerFullNameMatch || serviceTypeMatch || customRolesMatch;
    });

    setFilteredRows(filtered);
  };

  useEffect(() => {
    setFilteredRows(groupRows);
  }, [groupRows]);

  // Handle sorting
  const handleSort = (key) => {
    let direction = 'ascending';

    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }

    setSortConfig({ key, direction });
  };

  const sortedRows = useMemo(() => {
    let rowsToSort = filteredRows;

    if (!sortConfig.key) return rowsToSort;

    return [...rowsToSort].sort((a, b) => {
      if (sortConfig.key === 'group') {
        const aValue = a.selectedGroup?.newGroupName || '';
        const bValue = b.selectedGroup?.newGroupName || '';

        if (aValue < bValue) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      }

      if (sortConfig.key === 'manager') {
        const aValue = a.selectedManager
          ? `${a.selectedManager.EmpFirstName} ${a.selectedManager.EmpLastName}`
          : '';
        const bValue = b.selectedManager
          ? `${b.selectedManager.EmpFirstName} ${b.selectedManager.EmpLastName}`
          : '';

        if (aValue < bValue) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      }

      if (sortConfig.key === 'title') {
        const aValue = a.selectedManager
          ? [
            a.selectedManager?.servicetype,
            ...(a.selectedManager?.customRoles || [])
          ].filter(Boolean).join('  ')
          : '';
        const bValue = b.selectedManager
          ? [
            b.selectedManager?.servicetype,
            ...(b.selectedManager?.customRoles || [])
          ].filter(Boolean).join('  ')
          : '';

        if (aValue < bValue) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      }

      return 0;
    });
  }, [filteredRows, sortConfig]);

  // Always keep Group in sync with latest employeeGroups so dropdown and table show fresh data
  useEffect(() => {
    const userEmail = localStorage.getItem('email');
    if (userEmail && employeeGroups?.length !== undefined) {
      const filteredGroups = employeeGroups.filter(
        (g) => g.createdBy && g.createdBy.EmpEmail === userEmail
      );
      setGroup(filteredGroups);
    }
  }, [employeeGroups]);

  useEffect(() => {
    if (!AssignedGroup) {
      setFilteredRows([]);
    } else {
      const selectedGroup = GroupNames.find(g => g.newGroupName === AssignedGroup);
      const filtered = groupRows
        .map(row => {
          // If no group is selected in row, use the filter group
          if (!row.selectedGroup && selectedGroup) {
            return { ...row, selectedGroup: selectedGroup };
          }
          return row;
        })
        .filter(row => {
          const rowGroupId = row.selectedGroup?._id;
          const selectedGroupId = selectedGroup?._id;

          // Prefer matching by group _id when available
          if (rowGroupId && selectedGroupId) {
            return rowGroupId === selectedGroupId;
          }

          // Fallback to matching by group name
          return row.selectedGroup?.newGroupName === AssignedGroup;
        });

      if (filtered?.length > 0) {
        setFilteredRows(filtered);
      }
      else {
        const newId = Date.now();
        const selectedGroup = GroupNames.find(g => g.newGroupName === AssignedGroup);
        const blankRow = {
          id: null,
          rowKey: `new-${newId}`,
          selectedGroup: selectedGroup,
          selectedManager: null,
          isExisting: false,
        };
        // Instead of replacing filteredRows, update groupRows and filteredRows
        setGroupRows([blankRow]);
        setFilteredRows([blankRow]);
      }
    }
  }, [groupRows, AssignedGroup, GroupNames]);
  // Fetch initial data
  useEffect(() => {
    dispatch(fetchEmployeeGroups());
    dispatch(fetchGroups());
    dispatch(fetchEmployees());
  }, [dispatch]);

  // Set group names
  useEffect(() => {
    setGroupNames(group);
  }, [group]);

  useEffect(() => {
    const Managers = employees.filter((emp) =>
      emp.EmpAuthLevel === "L4"
    );
    const projectManagers = Managers.filter((emp) =>
      emp.customRoles && emp.customRoles.includes("project manager")
    );
    setEmployees(projectManagers);
  }, [employees]);

  // Set page title
  useEffect(() => {
    dispatch(setCurrentPageTitle("Add  Member"));
  }, [dispatch]);
  useEffect(() => {
    const prefilledRows = Group.map((item) => ({
      id: item._id,
      rowKey: `existing-${item._id}`,
      selectedGroup: item.groupId,
      selectedManager: item.employeeId,
      isExisting: true,
    }));

    // If there are no existing rows from backend, add a blank row
    if (prefilledRows.length === 0) {
      const newId = Date.now();
      // Get the group from filter if a specific group is selected
      const selectedGroup = AssignedGroup !== "All" && AssignedGroup
        ? GroupNames.find(g => g.newGroupName === AssignedGroup)
        : null;

      const blankRow = {
        id: null,
        rowKey: `new-${newId}`,
        selectedGroup: selectedGroup, // Include the group from filter
        selectedManager: null,
        isExisting: false,
      };
      setGroupRows([blankRow]);
      setInitialGroupRows([blankRow]);
    } else {
      setGroupRows(prefilledRows);
      setInitialGroupRows(prefilledRows);
    }
  }, [Group, AssignedGroup, GroupNames]); // Add dependencies


  // Close dropdowns when clicking outside - FIXED VERSION
  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideAll = Object.keys(dropdownRefs.current).every(dropdownId => {
        const dropdownRef = dropdownRefs.current[dropdownId];
        return !dropdownRef || !dropdownRef.contains(event.target);
      });

      if (clickedOutsideAll) {
        setOpenDropdowns({
          group: {},
          manager: {}
        });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Modal handlers
  const closeDeleteModal = () => setIsModalOpen(false);

  // Row management
  // Update the handleAddRow function
  const handleAddRow = () => {
    if (!canAddMember) {
      enqueueSnackbar("You do not have permission to add members.", {
        variant: "warning",
      });
      return;
    }
    const newId = Date.now(); // Using timestamp for unique ID

    // Get the group from filter if a specific group is selected
    const selectedGroup = AssignedGroup !== "All" && AssignedGroup
      ? GroupNames.find(g => g.newGroupName === AssignedGroup)
      : null;

    setGroupRows([
      ...groupRows,
      {
        id: null,
        rowKey: `new-${newId}`,
        selectedGroup: selectedGroup, // Include the group from filter
        selectedManager: null,
        isExisting: false,
      },
    ]);
  };





  const toggleDropdown = (type, rowKey) => {
    setOpenDropdowns(prev => {
      const isCurrentlyOpen = prev[type]?.[rowKey];

      return {
        group: {},
        manager:
          type === "manager"
            ? (isCurrentlyOpen ? {} : { [rowKey]: true })
            : {}
      };
    });
  };


  // Check if a row is modified
  const isRowModified = (row) => {
    if (!row.isExisting) return false;
    const initialRow = initialGroupRows.find(initial => initial.id === row.id);
    if (!initialRow) return false;
    return (
      row.selectedGroup?._id !== initialRow.selectedGroup?._id ||
      row.selectedManager?._id !== initialRow.selectedManager?._id
    );
  };

  // Handle form submission
  const handleSubmit = async () => {
    // Separate new and existing rows
    const newRows = groupRows.filter(row => !row.isExisting);
    const existingRows = groupRows.filter(row => row.isExisting);
    const currentGroup = AssignedGroup;


    console.log("currentGroupcurrentGroup handleSubmit1", currentGroup)
    // Prepare new entries
    const newEntries = newRows.map(row => ({
      groupId: row.selectedGroup?._id || null,
      employeeId: row.selectedManager?._id || null,
    }));

    // Prepare updates for modified rows
    const updates = existingRows
      .filter(row => isRowModified(row))
      .map(row => ({
        _id: row.id,
        data: {
          groupId: row.selectedGroup?._id,
          employeeId: row.selectedManager?._id
        }
      }));

    // Permission checks based on requested operations
    if (newEntries.length > 0 && !canAddMember) {
      enqueueSnackbar("You do not have permission to add members.", {
        variant: "warning",
      });
      return;
    }

    if (updates.length > 0 && !canEditMember) {
      enqueueSnackbar("You do not have permission to edit members.", {
        variant: "warning",
      });
      return;
    }

    // Validate new entries
    if (newEntries.some(entry => !entry.groupId || !entry.employeeId)) {
      enqueueSnackbar("Please fill all the fields for every new row!", {
        variant: "error",
        autoHideDuration: 3000
      });
      return;
    }

    // Check for duplicates with existing backend group mappings
    const duplicates = newEntries.filter(entry =>
      Group.some(existing =>
        existing.groupId?._id === entry?.groupId &&
        existing.employeeId?._id === entry?.employeeId
      )
    );

    if (duplicates.length > 0) {
      duplicates.forEach(entry => {
        const matched = Group.find(g =>
          g.groupId._id === entry.groupId && g.employeeId._id === entry.employeeId
        );
        if (matched) {
          const groupName = matched.groupId.newGroupName;
          const managerName = `${matched.employeeId.EmpFirstName} ${matched.employeeId.EmpLastName}`;
          enqueueSnackbar(`Duplicate entry found: Group - ${groupName}, Manager - ${managerName}`, {
            variant: "error",
            autoHideDuration: 3000
          });
        }
      });
      return;
    }

    SetisLoading(true);
    try {
      // Process new entries
      if (newEntries.length > 0) {
        const newResult = await dispatch(createEmployeeGroups(newEntries));
        if (newResult.error) {
          throw newResult.error;
        }
        enqueueSnackbar(`${newEntries.length} new member(s) added successfully!`, {
          variant: "success",
          autoHideDuration: 3000
        });
      }

      // Process updates with individual error handling
      if (updates.length > 0) {
        let successCount = 0;

        for (const update of updates) {
          try {
            const result = await dispatch(updateEmployeeGroup(update));

            if (result.meta.requestStatus === 'rejected') {
              // Show backend error message in red snackbar
              const errorMsg = result.payload?.error || "Update failed";
              enqueueSnackbar(errorMsg, {
                variant: "error",
                autoHideDuration: 4000,
                persist: result.payload?.error ? true : false
              });
            } else {
              successCount++;
            }
          } catch (error) {
            enqueueSnackbar(error.message || "Failed to update member", {
              variant: "error",
              autoHideDuration: 3000
            });
          }
        }

        if (successCount > 0) {
          enqueueSnackbar(`${successCount} member(s) updated successfully!`, {
            variant: "success",
            autoHideDuration: 3000
          });
        }
      }
      // Refresh data
      dispatch(fetchEmployeeGroups());
      console.log("currentGroupcurrentGroup handleSubmit2", currentGroup)
      setTimeout(() => {
        setAssignedGroup(currentGroup);
      }, 80);

    } catch (error) {
      console.error("Submission error:", error);
      const errorMsg = error.response?.data?.error ||
        error.payload?.error ||
        error.message ||
        "Failed to submit changes";
      enqueueSnackbar(errorMsg, {
        variant: "error",
        autoHideDuration: 4000,
        persist: true
      });
    } finally {
      SetisLoading(false);
    }
  };

  // Delete handler
  const handledeleteRow = (id, index, rowKey) => {
    if (!canDeleteMember) {
      enqueueSnackbar("You do not have permission to delete members.", {
        variant: "warning",
      });
      return;
    }
    if (id) {
      setRowToDelete(id);
      setIsModalOpen(true);
    } else {
      setRowKeyToDelete(rowKey);
      setIsModal(true)
    }
  };

  const closeAllDropdowns = () => {
    setOpenDropdowns({
      group: {},
      manager: {}
    });
  };

  const confirmDelete = async () => {
    if (!canDeleteMember) {
      enqueueSnackbar("You do not have permission to delete members.", {
        variant: "warning",
      });
      setIsModalOpen(false);
      return;
    }
    SetisLoading(true);
    try {
      // Store current AssignedGroup before deletion
      const currentGroup = AssignedGroup;
      console.log("currentGroupcurrentGroup confirmDelete1", currentGroup)

      await dispatch(deleteEmployeeGroup(_id));
      enqueueSnackbar("Row Deleted Successfully!", { variant: "success" });

      // Refresh data
      // dispatch(fetchEmployeeGroups());
      console.log("currentGroupcurrentGroup confirmDelete2", currentGroup)

      // Restore the AssignedGroup after refresh
      setAssignedGroup(currentGroup);
    } catch (error) {
      console.error("Failed to delete row:", error);
      enqueueSnackbar("Failed to delete row", { variant: "error" });
    } finally {
      SetisLoading(false);
      closeAllDropdowns();
      setRowToDelete(null);
      setIsModalOpen(false);
    }
  };
  const groupdownRef = useRef(null);
  const handleClickOutsidegroup = (e) => {
    if (groupdownRef.current && !groupdownRef.current.contains(e.target)) {
      setIsGroupOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutsidegroup);
    return () => {
      document.removeEventListener("click", handleClickOutsidegroup);
    };
  }, []);

  useEffect(() => {
    const userEmail = localStorage.getItem('email');
    if (userEmail && employeeGroups && !hasUserSelectedGroup.current && !AssignedGroup) {
      const filteredGroups = employeeGroups?.filter(group =>
        group?.createdBy && group?.createdBy?.EmpEmail === userEmail
      );

      // Group by newGroupName
      const groupedByNewGroupName = filteredGroups?.reduce((acc, group) => {
        const groupName = group?.groupId?.newGroupName || group?.groupId?.newGroupName;

        if (!acc[groupName]) {
          acc[groupName] = [];
        }
        acc[groupName].push(group);
        return acc;
      }, {});

      console.log("Grouped by newGroupName:", groupedByNewGroupName);

      let groupNameToStore = '';

      // Check if Sensr exists and has entries
      if (groupedByNewGroupName['Sensr'] && groupedByNewGroupName['Sensr']?.length > 0) {
        groupNameToStore = 'Sensr';
      } else {
        // Find the group with the maximum number of entries
        let maxEntries = 0;
        let maxGroupName = '';

        Object.entries(groupedByNewGroupName).forEach(([groupName, entries]) => {
          if (entries.length > maxEntries) {
            maxEntries = entries.length;
            maxGroupName = groupName;
          }
        });

        // If there's a group with entries (more than 0)
        if (maxEntries > 0) {
          groupNameToStore = maxGroupName;
        }
      }

      // Set the group name in state only for initial load
      if (groupNameToStore) {
        setAssignedGroup(groupNameToStore);
        console.log("Selected group name:", groupNameToStore);
      }
    }
  }, [employeeGroups, AssignedGroup]);

  return (
    <>
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={closeDeleteModal}
        onConfirm={confirmDelete}
      />

      {isLoading && (
        <AdminLoader isLoading={isLoading} />
      )}

      <>
        <div className="pt-6">
          <div className="mr-4 p-4 min-h-[20rem] bg-white  rounded-md border border-gray-200 shadow-lg">

            <div className=" px-[2rem] py-2 align-middle items-center">
              <div className="flex justify-between gap-2 ">
                <div
                  className="relative flex gap-2 justify-center align-middle items-center"
                  ref={groupdownRef}
                >
                  <label
                    htmlFor="selectedStatus"
                    className="block text-sm font-semibold text-gray-700 "
                  >
                    GROUP
                  </label>
                  <button
                    type="button"
                    onClick={() => {
                      if (!isGroupOpen) {
                        dispatch(fetchEmployeeGroups());
                      }
                      setIsGroupOpen(!isGroupOpen);
                    }}
                    className="w-24 relative outline-none date-picker-placeholder flex justify-start border border-[#e0e7ff] rounded-md p-2 text-xs"
                  >
                    <span
                      className="truncate min-w-0 flex-1 text-left"
                    >
                      {AssignedGroup ? AssignedGroup : "All"}
                    </span>
                    <ExpandMoreIcon className="absolute cursor-pointer right-1 top-1 bg-white" />
                  </button>
                  {isGroupOpen && (
                    <div className="absolute left-0 top-full w-full text-xs border overflow-hidden text-wrap border-gray-400 bg-white shadow-md rounded-md z-50">
                      {/* <div
                          className={`flex items-center p-2 hover:bg-gray-200 cursor-pointer ${AssignedGroup === "All" ? "bg-gray-300" : ""
                            }`}
                          onClick={() => {
                            setAssignedGroup("All"); // ✅ Set to All
                            setIsGroupOpen(false);

                          }}
                        >
                          <label>All</label>
                        </div> */}

                      {GroupNames.map((group) => (
                        <div
                          key={group.id}
                          className={`flex items-center p-2 hover:bg-gray-200 cursor-pointer ${AssignedGroup === group.newGroupName
                            ? "bg-gray-300"
                            : ""
                            }`}
                          onClick={() => {
                            hasUserSelectedGroup.current = true;
                            setAssignedGroup(group.newGroupName);
                            setIsGroupOpen(false);
                          }}
                        >
                          <label>{group.newGroupName}</label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                  <MdSearch className=" w-5 h-5 text-gray-500" />
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                    placeholder="Search"
                    className="bg-[#e0e7ff] outline-none w-[80%]"
                  />
                </div>
              </div>
            </div>

            <div className="w-full text-xs">
              <div className="flex w-full px-[2rem] ">
                <div
                  className="w-[50%] relative flex justify-between align-middle items-center bg-[#e8e8e8] font-semibold p-2  cursor-pointer"
                  onClick={() => handleSort('manager')}
                >
                  Manager
                  <div className="flex absolute top-0 right-2 flex-col">
                    <div className="cursor-pointer">
                      <ArrowDropUp
                        sx={{
                          fontSize: "22px",
                        }}
                      />
                    </div>
                    <div className="cursor-pointer -mt-2">
                      <ArrowDropDown
                        sx={{
                          fontSize: "22px",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="w-[50%] relative flex justify-between align-middle items-center bg-[#e8e8e8] font-semibold p-2 b cursor-pointer"
                  onClick={() => handleSort('title')}
                >
                  Service Type
                  <div className="flex absolute top-0 right-2 flex-col">
                    <div className="cursor-pointer">
                      <ArrowDropUp
                        sx={{
                          fontSize: "22px",

                        }}
                      />
                    </div>
                    <div className="cursor-pointer -mt-2">
                      <ArrowDropDown
                        sx={{
                          fontSize: "22px",

                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-[5.5%] bg-[#e8e8e8] font-semibold p-2  text-center">
                  <DeleteIcon />
                </div>
              </div>
            </div>
            <div className="w-full text-xs">
              <div className="Grouplist w-full">
                {sortedRows.length > 0 ? (
                  sortedRows.map((row, index) => {
                    // const groupDropdownId = `group-${row.rowKey}`;
                    const managerDropdownId = `manager-${row.rowKey}`;

                    return (
                      <div
                        key={row.rowKey}
                        className="mainrow flex w-full px-[2rem]"
                        onMouseEnter={() => setHoveredRowId(row.id)}
                        onMouseLeave={() => setHoveredRowId(null)}
                      >
                        {/* Manager Dropdown */}
                        <div className="Managerrow w-[50%]  p-1 border-b border-l ">
                          <div
                            ref={el => dropdownRefs.current[managerDropdownId] = el}
                            className="relative flex p-0 rounded-xl align-middle items-center"
                          >
                            <ExpandMoreIcon
                              onClick={() => {
                                const isExisting = !!row.isExisting;
                                const allowed = isExisting ? canEditMember : canAddMember;
                                if (!allowed) return;
                                toggleDropdown('manager', row.rowKey);
                              }}
                              className={`absolute cursor-pointer right-2 m-auto ${
                                (row.isExisting ? !canEditMember : !canAddMember)
                                  ? "text-gray-400 cursor-not-allowed"
                                  : "text-black"
                              }`}
                            />
                            <button
                              type="button"
                              onClick={() => {
                                const isExisting = !!row.isExisting;
                                const allowed = isExisting ? canEditMember : canAddMember;
                                if (!allowed) return;
                                toggleDropdown('manager', row.rowKey);
                              }}
                              className={`border w-full border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${
                                (row.isExisting ? !canEditMember : !canAddMember)
                                  ? "text-gray-400 bg-gray-100 cursor-not-allowed"
                                  : "text-black"
                              }`}
                            >
                              {row.selectedManager ? (
                                `${row.selectedManager.EmpFirstName} ${row.selectedManager.EmpLastName}`
                              ) : (
                                <span>Select Manager</span>
                              )}
                            </button>
                            {openDropdowns.manager[row.rowKey] && (
                              <div
                                style={{ zIndex: 999 }}
                                className="absolute max-h-60 overflow-auto top-full left-0 w-full p-1 cursor-pointer text-black bg-white border border-gray-300 shadow-lg flex flex-col gap-1"
                              >
                                {(() => {
                                  // 🔹 Current group (row group OR filter group)
                                  const currentGroup =
                                    row.selectedGroup ||
                                    (AssignedGroup !== "All" && AssignedGroup
                                      ? GroupNames.find(g => g.newGroupName === AssignedGroup)
                                      : null);

                                  // 🔹 All already assigned managers (GLOBAL or GROUP-wise)
                                  const assignedManagerIds = groupRows
                                    .filter(r => {
                                      if (!r.selectedManager?._id) return false;

                                      // If group selected → block only same group
                                      if (currentGroup) {
                                        return r.selectedGroup?._id === currentGroup._id;
                                      }

                                      // If "All" → block globally
                                      return true;
                                    })
                                    .map(r => r.selectedManager._id);

                                  // 🔹 Available managers
                                  const availableManagers = Employees.filter(emp => {
                                    // Must be project manager
                                    const isProjectManager =
                                      emp.customRoles?.includes("project manager");

                                    if (!isProjectManager) return false;

                                    // If group selected → manager must belong to group
                                    if (currentGroup) {
                                      const belongsToGroup =
                                        emp.EmpGroups &&
                                        (Array.isArray(emp.EmpGroups)
                                          ? emp.EmpGroups.includes(currentGroup.newGroupName) ||
                                          emp.EmpGroups.includes(currentGroup._id)
                                          : emp.EmpGroups === currentGroup.newGroupName ||
                                          emp.EmpGroups === currentGroup._id);

                                      if (!belongsToGroup) return false;
                                    }

                                    // ❌ DO NOT show already assigned managers (even current row)
                                    return !assignedManagerIds.includes(emp._id);
                                  });

                                  // 🔹 No data case
                                  if (availableManagers.length === 0) {
                                    return (
                                      <div className="text-gray-500 p-2 text-center">
                                        No available project managers
                                      </div>
                                    );
                                  }

                                  // 🔹 Render list
                                  return availableManagers.map(emp => (
                                    <div
                                      key={emp._id}
                                      className="p-1 hover:bg-gray-200"
                                      onClick={() => {
                                        setOpenDropdowns({ group: {}, manager: {} });

                                        const updatedRows = groupRows.map(r =>
                                          r.rowKey === row.rowKey
                                            ? {
                                              ...r,
                                              selectedManager: emp,
                                              selectedGroup: currentGroup
                                            }
                                            : r
                                        );

                                        setGroupRows(updatedRows);

                                        // Sync filteredRows
                                        if (filteredRows.some(fr => fr.rowKey === row.rowKey)) {
                                          setFilteredRows(
                                            filteredRows.map(r =>
                                              r.rowKey === row.rowKey
                                                ? {
                                                  ...r,
                                                  selectedManager: emp,
                                                  selectedGroup: currentGroup
                                                }
                                                : r
                                            )
                                          );
                                        }
                                      }}
                                    >
                                      {emp.EmpFirstName} {emp.EmpLastName}
                                    </div>
                                  ));
                                })()}
                              </div>
                            )}


                          </div>
                        </div>
                        <div className="Titlerow w-[50%] flex justify-between align-middle items-center pr-2  p-1 border-b">
                          <p>
                            {[
                              row.selectedManager?.servicetype,
                            ].filter(Boolean).join('  ')}
                          </p>
                        </div>
                        <div className="w-[5.5%]  flex justify-center align-middle items-center pr-2 p-1 border-b border-r">
                          {hoveredRowId === row.id && canDeleteMember && (
                            <DeleteIcon
                              onClick={() => handledeleteRow(row.id, index, row.rowKey)}
                              className="deleteicon cursor-pointer text-[#df3b3b]"
                            />
                          )}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="flex justify-center items-center w-full py-8">
                    <div className="text-center">
                      <div className=" text-lg font-medium text-red-600 mb-2">
                        {searchQuery ? "No data found" : "No members Found"}
                      </div>

                    </div>
                  </div>
                )}

                {!searchQuery && AssignedGroup && (
                  <div className="flex justify-center items-center w-full relative mt-2 mb-4">
                    <div className="absolute left-0 top-0 rounded-md p-1 shadow-lg border flex justify-center items-center bg-white">
                      <AddIcon
                        onClick={handleAddRow}
                        className="cursor-pointer text-black"
                      />
                    </div>

                  </div>
                )}
              </div>
            </div>

            <div className="flex justify-end pt-8">
              <button
                onClick={handleSubmit}
                className={`px-3 py-2 font-semibold rounded-md flex items-center gap-1 ${
                  !canAddMember && !canEditMember
                    ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                    : "bg-[#1973eb] text-white"
                }`}
                disabled={!canAddMember && !canEditMember}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </>



      {isModal && (
        <div className="fixed inset-0 flex items-center justify-center z-[1400] bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md">
            <h2 className="text-xl font-semibold mb-4 text-center">
              Confirm Deletion
            </h2>
            <p className="text-gray-700 mb-6 text-center">
              Are you sure you want to delete?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setIsModal(false);
                  setRowKeyToDelete(null);
                }}
                className="px-4 py-2 rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 text-gray-700"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  // Remove from both filteredRows and groupRows using rowKey
                  if (rowKeyToDelete) {
                    setFilteredRows((prevRows) => prevRows.filter((r) => r.rowKey !== rowKeyToDelete));
                    setGroupRows((prevRows) => prevRows.filter((r) => r.rowKey !== rowKeyToDelete));
                  }
                  setIsModal(false);
                  setRowKeyToDelete(null);
                  enqueueSnackbar("Row Deleted Successfully", {
                    variant: "success",
                  });
                }}
                className="px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-semibold"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )
      }
    </>
  );
};

export default MyMember;